import { Box, Grid2, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as LockIcon } from "Assets/Icons/Home/LockIcon.svg";
import { ReactComponent as UnlockIcon } from "Assets/Icons/Home/UnlockIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { SwiperSlide } from "swiper/react";
import PrimarySlider from "Components/Common/PrimarySlider";

const styles = (theme) => ({
  "& .list": {
    marginTop: "10px",
  },
  "& .calenderBox": {
    padding: "10px 15px",
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background-color 0.3s ease, color 0.3s ease",
    "& svg": {
      marginLeft: "auto",
    },
    "&:hover": {
      background: theme.palette.primary.main,
      color: theme.palette.white.main,
      "& svg": {
        fill: theme.palette.white.main,
      },
    },
  },
});

const Calendar = () => {
  return (
    <Grid2 sx={styles}>
      <Typography fontWeight={500} variant="subtitle">
        Calendar
      </Typography>
      <Grid2 className="list">
        <PrimarySlider>
          {[...Array(10)]?.map((item, i) => {
            return (
              <SwiperSlide key={i}>
                <Grid2 className="calenderBox" key={`slide${i}`} size={2}>
                  <Box display={"flex"} gap="10px" alignItems={"center"}>
                    <Typography
                      fontWeight={500}
                      variant="subtitle"
                      whiteSpace={"nowrap"}
                    >
                      26-Oct
                    </Typography>
                    <Typography>Chisquared test</Typography>
                    <PrimaryIcon icon={LockIcon} width="14px" height="18px" />
                  </Box>
                </Grid2>
              </SwiperSlide>
            );
          })}
        </PrimarySlider>
      </Grid2>
    </Grid2>
  );
};

export default Calendar;
